module.exports = __webpack_public_path__ + "static/img/video.f35ec5ea.gif";